import { render, staticRenderFns } from "./minimal_index_item.vue?vue&type=template&id=224fca21&scoped=true&"
import script from "./minimal_index_item.vue?vue&type=script&lang=js&"
export * from "./minimal_index_item.vue?vue&type=script&lang=js&"
import style0 from "./minimal_index_item.vue?vue&type=style&index=0&id=224fca21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224fca21",
  null
  
)

export default component.exports